import { fetchCompany } from '../api/company.api'
import { CompanyModel } from '../models/company.model'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { usePortalQuery } from 'src/Libs/api'

type DataReturnType = [CompanyModel | undefined, () => void, boolean, boolean]

/**
 * Hook to query company via ID
 */
export const useFetchCompany = (companyId: string | number | undefined): DataReturnType => {
  const authFetch = useAuthFetchWithResponse()

  const queryFn = async (): Promise<CompanyModel | null> => {
    const { error, hasErrors, value } = await fetchCompany(companyId, authFetch)

    if (hasErrors) {
      throw error || new Error('An unexpected error occurred when fetching company')
    }

    return value
  }

  const { data, isLoading, isError, refetch } = usePortalQuery({
    queryKey: ['users', 'companies', companyId],
    queryFn,
    enabled: !!companyId,
  })

  return [data || undefined, refetch, isLoading, isError]
}
